<template>
    <section id="filtered-resources-container">

        <h1>Vælg lokale</h1>

        <div id="filtered-resources">

            <resources v-on:resource-pick="pickResource()" />

            <section id="filters">
                <h2 class="label">Filtrér liste</h2>
                <form class="filters" @submit.prevent="updateList()">

                    <admin-unit-filter v-on:filter="changeFilter" />
                    <period-filter v-on:filter="changeFilter" />
                    <resource-type-filter v-on:filter="changeFilter" />
                    <capacity-filter v-on:filter="changeFilter" />
                    <public-filter v-on:filter="changeFilter" />
                    
                </form>
            </section>

        </div>

    </section>
</template>

<script>

    import axios from '../../utils/Http.js'
    import resources from './Resources.vue'
    import adminUnitFilter from './resource-filters/AdminUnitFilter.vue'
    import resourceTypeFilter from './resource-filters/TypeFilter.vue'
    import publicFilter from './resource-filters/PublicFilter.vue'
    import capacityFilter from './resource-filters/CapacityFilter.vue'
    import periodFilter from './resource-filters/PeriodFilter.vue'

    export default {
        components: {
            resources,
            adminUnitFilter,
            resourceTypeFilter,
            publicFilter,
            capacityFilter,
            periodFilter
        },
        data: function() {
            return {
                query: {}
            }
        },
        methods: {
            changeFilter: function(filter_obj) {
                for (const key in filter_obj) {
                    this.query[key] = filter_obj[key]
                }
                this.updateList()
            },
            updateList: function() {
                let q = '/booking/room/?'
                for (const key in this.query) {
                    let value = this.query[key]
                    if (value && value !== 'null') {
                        q = q + key + '=' + value + '&'
                    }
                }
                this.$store.dispatch('fetchResources', q)
            },
            pickResource: function(res) {
                this.$emit('filtered-resource-pick', res)
            },
            readQueryFromUrl: function() {
                // Update query with URL params and update list accordingly
                for (const p in this.$route.query) {
                    this.query[p] = this.$route.query[p]
                }
                this.updateList()
            }
        },
        created: function() {
            this.readQueryFromUrl()
        }
    }
</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    #filtered-resources-container > h1 {
        padding: 0 1rem;
    }

    #filtered-resources {
        padding: 0 1rem;
        display: flex;
        flex-flow: column nowrap;

        #filters {
            padding: 0 0 1rem;
            order: 1;
        }
        #resources {
            order: 2;
        }
    }

    @media screen and (min-width: $wide) {
        
        #filtered-resources  {
            flex-flow: row nowrap;
            min-width: 100vw;

            #filters {
                flex: 0 1 auto;
                padding: 0 1rem 1rem 0;
            }
            #resources {
                flex: 0 1 100%;
            }
        }
    }

</style>
